import ModalBasicLayout, { ModalActionsPortal } from "../ModalBasicLayout";
import { useTranslationApp } from "../../../lib/i18next";
import {
  ACTIVE,
  BUTTON_GO_BACK,
  BUTTON_DUPLICATE_CAMPAIGN,
  BUTTON_IMPORT_CAMPAIGN,
  DEACTIVATED,
  FILTER_BY_NAME,
  FILTER_BY_STATUS,
  FINISHED,
  MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION,
  MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_TITLE,
  MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES,
  MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES,
  PLATFORM_PLACEHOLDER,
} from "../../../i18n/keysTranslations";
import { SimpleAlert } from "../../Alerts/Alerts";
import { FormProvider, useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Select from "../../Form/Select";
import {
  AD_ACCOUNT_PLATFORMS_LABELS,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_STATUS_FINISHED,
  ALERT_ICON_TYPE_SUCCESS,
  GOOGLE,
  PLATFORMS_SUPPORTED,
} from "../../../utils/constants";
import { optionsCampaignsTypeGoogleAds } from "../../../utils/options";
import SelectBusinessAccount from "../../Meta/SelectBusinessAccount";
import { useDispatchApp, useSelectorApp } from "../../../lib/redux";
import { useEffect, useState, useRef } from "react";
import {
  getIsBlockedActions,
  getPlatformFromIntegrationKey,
} from "../../../actions/getters";
import { useCreditActionCosts } from "../../../hooks/useCreditActionCosts";
import ContainerModalActions from "../../Containers/ContainerModalActions";
import { useInView } from "react-intersection-observer";
import ImportAdsCampaignList from "./ImportAdsCampaignList";
import {
  startGetAdsCampaignsFromPlatform,
  startImportAdsCampaign,
} from "../../../actions/adsCampaigns";
import Loader from "../../Loaders/Loader";
import { useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import TextField from "../../Form/TextField";
import { useDebounced } from "../../../hooks/useDebounce";
import RangeDateField from "../../Form/RangeDateField";
import { applyFiltersImportAdsCampaigns } from "../../../services/adsCampaigns";
import { INPUT_COLOR_BORDER } from "../../../utils/colors";
import { markCampaignAsJustImported } from "../../../utils/importedCampaignAlert";

const ModalImportAdsCampaign = ({
  modalOpen,
  onCloseModal = () => {},
  embedded = false,
  duplicateStructureOnly = false,
}) => {
  const titleKey = duplicateStructureOnly
    ? MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE
    : MODAL_IMPORT_ADS_CAMPAIGN_TITLE;
  const descriptionKey = duplicateStructureOnly
    ? MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION
    : MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION;
  const successTitleKey = duplicateStructureOnly
    ? MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE
    : MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE;
  const successDescriptionKey = duplicateStructureOnly
    ? MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION
    : MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION;
  const submitButtonKey = duplicateStructureOnly
    ? BUTTON_DUPLICATE_CAMPAIGN
    : BUTTON_IMPORT_CAMPAIGN;
  const supportedTypesKey = duplicateStructureOnly
    ? MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES
    : MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES;

  const [isLoading, setIsLoading] = useState(true);
  const [isFirstLoadingCampaigns, setIsFirstLoadingCampaigns] = useState(true);
  const [campaigns, setCampaigns] = useState([]);
  const [loadedLastCampaign, setLoadedLastCampaign] = useState(false);
  const [lastKey, setLastKey] = useState(null);
  const [isImportingCampaign, setIsImportingCampaign] = useState(false);
  const abortControllerRef = useRef(null);
  const methods = useForm({
    defaultValues: {
      platform: "",
      integrationID: "",
      adAccountID: "",
      campaignID: "",
      name: "",
      dateRange: {
        startDateTime: "",
        endDateTime: "",
      },
    },
  });
  const { control, watch, setValue } = methods;
  const platform = watch("platform");
  const integrationID = watch("integrationID");
  const adAccountID = watch("adAccountID");
  const campaignID = watch("campaignID");
  const name = watch("name");
  const dateRange = watch("dateRange");

  const { t, i18n } = useTranslationApp();
  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const { ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION } = useCreditActionCosts();
  const { integrations = {} } = useSelectorApp((state) => state.user);

  const { ref, inView } = useInView({
    triggerOnce: false,
    rootMargin: "20px 0px",
  });

  const [statusFilter, setStatusFilter] = useState();

  const onCleanItemsSelected = () => {
    setValue("campaignID", "");
    setCampaigns([]);
    setLastKey(null);
    setLoadedLastCampaign(false);
    setIsFirstLoadingCampaigns(true);
  };

  const onChangePlatform = () => {
    setValue("adAccountID", "");
    onCleanItemsSelected();
  };
  const onChangeAdAccount = (value) => {
    setValue("integrationID", value?.integrationID);
    onCleanItemsSelected();
  };
  const onChangeName = () => {
    onCleanItemsSelected();
  };
  const onChangeDateRange = () => {
    onCleanItemsSelected();
  };

  const onGetAdsCampaigns = useDebounced(async () => {
    // Cancel previous request if it exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();

    const response = await dispatch(
      startGetAdsCampaignsFromPlatform({
        platform,
        integrationID,
        adAccountID,
        lastKey,
        onChangeLastKey: setLastKey,
        onChangeLoadLastItem: setLoadedLastCampaign,
        signal: abortControllerRef.current.signal,
        statusFilter,
        name,
        startDateTime: dateRange.startDateTime,
        endDateTime: dateRange.endDateTime,
      })
    );

    // If the request was aborted, don't update state
    if (response?.aborted) {
      return;
    }

    if (!response.ok) {
      setIsFirstLoadingCampaigns(false);
      setLoadedLastCampaign(true);
      return;
    }

    if (lastKey) {
      setCampaigns((prev) => [...prev, ...response.data]);
    } else {
      setCampaigns(response.data);
    }
    setIsFirstLoadingCampaigns(false);
  }, 1000);

  const onSelectCampaign = (campaign) => {
    setValue("campaignID", campaign.id);
  };

  const onImportCampaign = async () => {
    const isBlocked = await dispatch(
      getIsBlockedActions({
        action: ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION,
        multiplier: 1,
        showUsageConfirmationAlert: true,
      })
    );
    if (isBlocked) {
      return;
    }

    setIsImportingCampaign(true);
    const response = await dispatch(
      startImportAdsCampaign({
        platform,
        integrationID,
        adAccountID,
        campaignID,
        duplicateStructureOnly,
      })
    );
    setIsImportingCampaign(false);
    if (!response.ok) {
      return;
    }

    const newCampaignID = response.data.campaignID;
    if (!duplicateStructureOnly) {
      markCampaignAsJustImported(newCampaignID);
    }
    onCloseModal();
    navigate(`/ads-campaign?campaignID=${newCampaignID}`);
    SimpleAlert({
      title: t(successTitleKey),
      text: t(successDescriptionKey),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  useEffect(() => {
    const keysPlatforms = Object.keys(integrations || {});
    if (keysPlatforms.length > 0) {
      const firstPlatformSupported = keysPlatforms.find((key) =>
        PLATFORMS_SUPPORTED.includes(getPlatformFromIntegrationKey(key))
      );
      const firstPlatform = getPlatformFromIntegrationKey(
        firstPlatformSupported
      );
      setValue("platform", firstPlatform);
    }

    setIsLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (platform && integrationID && adAccountID) {
      onGetAdsCampaigns();
    }
    // Cleanup function to abort any pending requests when component unmounts or dependencies change
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
    // eslint-disable-next-line
  }, [
    platform,
    integrationID,
    adAccountID,
    name,
    dateRange?.startDateTime,
    dateRange?.endDateTime,
  ]);

  useEffect(() => {
    onCleanItemsSelected();
    // eslint-disable-next-line
  }, [dateRange?.startDateTime, dateRange?.endDateTime]);

  useEffect(() => {
    if (inView && !loadedLastCampaign) {
      onGetAdsCampaigns();
    }
    // Cleanup function to abort any pending requests when component unmounts or dependencies change
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
    // eslint-disable-next-line
  }, [inView]);

  // Filter campaigns based on statusFilter
  const filteredCampaigns = campaigns
    .filter((campaign) => {
      let pass = applyFiltersImportAdsCampaigns({
        campaign,
        status: statusFilter,
        name,
      });
      return pass;
    })
    .sort((a, b) => {
      return new Date(b.creationTime) - new Date(a.creationTime);
    });

  const body = (
    <>
      <FormProvider {...methods}>
        {!isLoading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Select
                name="platform"
                label={t(PLATFORM_PLACEHOLDER)}
                disabled={isImportingCampaign}
                variant="filled"
                fullWidth={true}
                options={PLATFORMS_SUPPORTED.map((platform) => ({
                  value: platform,
                  label: platform,
                }))}
                doTranslate={true}
                actionsChange={onChangePlatform}
                control={control}
              />
              {platform && (
                <SelectBusinessAccount
                  label={t(AD_ACCOUNT_PLATFORMS_LABELS[platform])}
                  disabled={isImportingCampaign}
                  disableCreateTikTokAdAccount
                  variant="filled"
                  fullWidth={true}
                  control={control}
                  platform={platform}
                  name={`adAccountID`}
                  onChangeAction={onChangeAdAccount}
                />
              )}
            </Box>
            {platform === GOOGLE && (
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: -1 }}
              >
                {t(supportedTypesKey, {
                  types: new Intl.ListFormat(i18n.language, {
                    style: "long",
                    type: "conjunction",
                  }).format(
                    optionsCampaignsTypeGoogleAds.map((campaignType) =>
                      t(campaignType.label)
                    )
                  ),
                })}
              </Typography>
            )}
            {platform && adAccountID && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <TextField
                  name="name"
                  placeholder={t(FILTER_BY_NAME)}
                  variant="filled"
                  fullWidth={true}
                  actionsChange={onChangeName}
                  control={control}
                />
                <RangeDateField
                  showStartNowButton={true}
                  control={control}
                  name="dateRange"
                  mode="form"
                  onSave={onChangeDateRange}
                  clearable={true}
                  sxField={{
                    color: "#000",
                    backgroundColor: "fields.background",
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                    border: `1px solid ${INPUT_COLOR_BORDER}`,
                    "& .MuiInputBase-root": {
                      color: "#000",
                      backgroundColor: "fields.background",
                    },
                    "& .MuiInputLabel-root": {
                      color: "black !important",
                    },
                  }}
                />
                <Typography variant="body1">{t(FILTER_BY_STATUS)}</Typography>
                <Box>
                  <Chip
                    label={t(ACTIVE)}
                    onClick={() => {
                      if (statusFilter === ADS_CAMPAIGN_STATUS_ACTIVE) {
                        setStatusFilter(null);
                      } else {
                        setStatusFilter(ADS_CAMPAIGN_STATUS_ACTIVE);
                      }
                    }}
                    sx={{
                      color:
                        statusFilter === ADS_CAMPAIGN_STATUS_ACTIVE
                          ? "white"
                          : "black",
                      background:
                        statusFilter === ADS_CAMPAIGN_STATUS_ACTIVE
                          ? "black"
                          : "white",
                      mr: 1,
                      borderRadius: "10px",
                      border: `1px solid ${INPUT_COLOR_BORDER}`,
                      "&:hover": {
                        background:
                          statusFilter === ADS_CAMPAIGN_STATUS_ACTIVE
                            ? "black"
                            : "white",
                        color:
                          statusFilter === ADS_CAMPAIGN_STATUS_ACTIVE
                            ? "white"
                            : "black",
                      },
                    }}
                  />
                  <Chip
                    label={t(DEACTIVATED)}
                    onClick={() => {
                      if (statusFilter === ADS_CAMPAIGN_STATUS_DEACTIVATED) {
                        setStatusFilter(null);
                      } else {
                        setStatusFilter(ADS_CAMPAIGN_STATUS_DEACTIVATED);
                      }
                    }}
                    sx={{
                      color:
                        statusFilter === ADS_CAMPAIGN_STATUS_DEACTIVATED
                          ? "white"
                          : "black",
                      background:
                        statusFilter === ADS_CAMPAIGN_STATUS_DEACTIVATED
                          ? "black"
                          : "white",
                      mr: 1,
                      borderRadius: "10px",
                      border: `1px solid ${INPUT_COLOR_BORDER}`,
                      "&:hover": {
                        background:
                          statusFilter === ADS_CAMPAIGN_STATUS_DEACTIVATED
                            ? "black"
                            : "white",
                        color:
                          statusFilter === ADS_CAMPAIGN_STATUS_DEACTIVATED
                            ? "white"
                            : "black",
                      },
                    }}
                  />
                  <Chip
                    label={t(FINISHED)}
                    onClick={() => {
                      if (statusFilter === ADS_CAMPAIGN_STATUS_FINISHED) {
                        setStatusFilter(null);
                      } else {
                        setStatusFilter(ADS_CAMPAIGN_STATUS_FINISHED);
                      }
                    }}
                    sx={{
                      color:
                        statusFilter === ADS_CAMPAIGN_STATUS_FINISHED
                          ? "white"
                          : "black",
                      background:
                        statusFilter === ADS_CAMPAIGN_STATUS_FINISHED
                          ? "black"
                          : "white",
                      borderRadius: "10px",
                      border: `1px solid ${INPUT_COLOR_BORDER}`,
                      "&:hover": {
                        background:
                          statusFilter === ADS_CAMPAIGN_STATUS_FINISHED
                            ? "black"
                            : "white",
                        color:
                          statusFilter === ADS_CAMPAIGN_STATUS_FINISHED
                            ? "white"
                            : "black",
                      },
                    }}
                  />
                </Box>
              </Box>
            )}
            {isFirstLoadingCampaigns && integrationID && adAccountID && (
              <Loader size={20} hasMarginTop={true} />
            )}
            {!isFirstLoadingCampaigns && (
              <ImportAdsCampaignList
                data={filteredCampaigns}
                platform={platform}
                lastItemRef={ref}
                loadedLastCampaign={loadedLastCampaign}
                selectedCampaign={campaignID}
                onSelectCampaign={onSelectCampaign}
                ignoreAlreadyCreated={duplicateStructureOnly}
              />
            )}
          </Box>
        )}
      </FormProvider>
    </>
  );

  const actions = (
    <DialogActions
      sx={{
        px: { xs: 3, sm: 5 },
        pb: 2,
        pt: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <ContainerModalActions
        hasPadding={false}
        propsSecondaryButton={{
          disabled: isImportingCampaign,
          showButton: !embedded,
          onClick: onCloseModal,
          text: BUTTON_GO_BACK,
        }}
        propsPrimaryButton={{
          showButton: true,
          disabled: !campaignID,
          text: submitButtonKey,
          type: "submit",
          onClick: onImportCampaign,
        }}
      />
    </DialogActions>
  );

  // Rendered inside another modal (e.g. the create campaign modal).
  if (embedded) {
    return (
      <>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h5"
            align="left"
            sx={{ fontWeight: 600, color: "background.paperContrastText" }}
          >
            {t(titleKey)}
          </Typography>
          <Typography
            variant="body1"
            align="left"
            sx={{ color: "background.paperContrastText" }}
          >
            {t(descriptionKey)}
          </Typography>
        </Box>
        {body}
        <ModalActionsPortal>{actions}</ModalActionsPortal>
      </>
    );
  }

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      maxWidth="md"
      title={t(titleKey)}
      description={t(descriptionKey)}
      sxTitle={{ color: "background.paperContrastText" }}
      sxDescription={{ color: "background.paperContrastText" }}
    >
      {body}
      {actions}
    </ModalBasicLayout>
  );
};

export default ModalImportAdsCampaign;
